module.exports = __webpack_public_path__ + "static/img/bgc3.a2bd86af.jpg";